<app-dialog-base [Title]='"Task"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Object'|translate}}</label>
    <input type="text" placeholder="" *ngIf="model.Tracker" [(ngModel)]="model.Tracker.Name"
           [readOnly]="true"/>
    <button class="btnlink" (click)="selectTracker()">{{ 'Select' | translate }}</button>
  </div>
  <div class="inputgroup">
    <label>{{'Name'|translate}}</label>
    <input type="text" placeholder="{{'Name'|translate}}" [(ngModel)]="model.Name"/>
  </div>
  <div class="inputgroup">
    <label>{{'Description'|translate}}</label>
    <input type="text" placeholder="{{'Description'|translate}}" [(ngModel)]="model.Description"/>
  </div>
  <div class="inputgroup">
    <label>{{'Time'|translate}}</label>
    <calendar [name]="'TaskCompletedDate'" [(date)]="model.TaskCompletedDate" [format]="'%0D.%0M.%0Y %0h:%0m'"></calendar>
  </div>
  <div class="inputgroup">
    <label>{{'Repeat'|translate}} </label>
    <select title="{{'Repeat'|translate}}" [(ngModel)]="model.Repeat">
      <option value="0" [selected]="model.Repeat == 0">{{'None'|translate}}</option>
      <option value="1" [selected]="model.Repeat == 1">{{'Daily'|translate}}</option>
      <option value="7" [selected]="model.Repeat == 7">{{'Weekly'|translate}}</option>
      <option value="30" [selected]="model.Repeat == 30">{{'Monthly'|translate}}</option>
    </select>
  </div>
  <div class="inputgroup">
    <label>{{'Task'|translate}} </label>
    <select title="{{'Task'|translate}}" [(ngModel)]="this.model.intTarget">
      <option value="Point" [selected]="this.model.intTarget == 'Point'">{{'Point arrival'|translate}}</option>
      <option value="Route" [selected]="this.model.intTarget == 'Route'">{{'Route'|translate}}</option>
      <option value="Geozone" [selected]="this.model.intTarget == 'Geozone'">{{'Geozone'|translate}}</option>
    </select>

  </div>
  <div class="inputgroup" *ngIf="this.model.intTarget == 'Point'">
    <label>{{'Coordinates'|translate}}</label>
    <input type="text" [(ngModel)]="coordinate" [readOnly]="true" (click)="selectPoint()"/>
  </div>
  <div class="inputgroup" *ngIf="this.model.intTarget == 'Point'">
    <label>{{'Radius'|translate}}</label>
    <label>
      <input type="text" placeholder="" [ngModel]="model.Radius | localizeMeters"  (ngModelChange)="convertRadius($event)" />
      <span>{{'m'|localizeUnits}}</span>
    </label>
  </div>
  <div class="inputgroup" *ngIf="this.model.intTarget == 'Geozone'">
    <label>{{'Geozone'|translate}}</label>
    <input type="text" placeholder="" *ngIf="model.Zone" [(ngModel)]="model.Zone.Name"
           [readOnly]="true"/>
    <button class="btnlink" (click)="selectGeoZone()">{{ 'Select' | translate }}</button>
  </div>
  <div class="inputgroup" *ngIf="this.model.intTarget == 'Route'">
    <label>{{'Route'|translate}}</label>
    <input type="text" placeholder="" *ngIf="model.Route" [(ngModel)]="model.Route.Name" [readOnly]="true"/>
    <button class="btnlink" (click)="selectRoute()">{{ 'Select' | translate }}</button>
  </div>
</app-dialog-base>
<template #objectsListDialog></template>
